import Icon from 'assets/components/icon/Icon';
import MultilineTextInput from 'assets/components/inputs/multilineText/MultilineTextInput';
import SelectInput from 'assets/components/inputs/select/SelectInput';
import { getLocales } from 'assets/locales/Locale';
import { usePublicClaimSubmitProvider } from '../../Claim.Submit.Hooks';
import { first } from 'lodash';

export default function ClaimSubmitClaimJobInfo() {
  const { lang } = getLocales();
  const { onlyClaimType, claimTypeValue, claimTypes, claimJobForUpdate, updateClaimJob, form } =
    usePublicClaimSubmitProvider();

  return (
    <>
      {!onlyClaimType && (
        <SelectInput
          name="claimTypeId"
          label={lang.claimType}
          data={claimTypes?.map((it) => it.displayInfo)}
          value={claimTypeValue}
          onChange={({ claimTypeId }) => updateClaimJob({ ...claimJobForUpdate, claimTypeId })}
          icon={<Icon class="fas-clipboard-list" />}
          error={!first(form.data.claim.claimJobs)?.claimTypeId && lang.required}
        />
      )}
      <MultilineTextInput
        name="customerComplaint"
        label={lang.customerComplaint}
        value={claimJobForUpdate?.customerComplaint}
        onChange={({ customerComplaint }) => updateClaimJob({ ...claimJobForUpdate, customerComplaint })}
      />
      <MultilineTextInput
        name="cause"
        label={lang.causeOfFailure}
        value={claimJobForUpdate?.cause}
        onChange={({ cause }) => updateClaimJob({ ...claimJobForUpdate, cause })}
      />
      <MultilineTextInput
        name="correction"
        label={lang.correctionDetails}
        value={claimJobForUpdate?.correction}
        onChange={({ correction }) => updateClaimJob({ ...claimJobForUpdate, correction })}
      />
    </>
  );
}
